import React from 'react';
import StarIcon from '@mui/icons-material/Star';
import { Opinion } from '../../models/Opinion';
import styles from './styles.module.scss';

type ItemOpinionProps = {
    item: Opinion
}

const ItemOpinion = ({ item }: ItemOpinionProps) => {

  const titulo = item?.attributes?.titulo;
  const mensaje = item?.attributes?.mensaje;
  const nombre = item?.attributes?.nombre;
  const localidad = item?.attributes?.localidad;

  return (
    <div className={styles.card}>
      <span className={styles.quoteIcon} aria-hidden="true">&rdquo;</span>
      <div className={styles.stars}>
        {Array.from({ length: 5 }).map((_, i) => (
          <StarIcon key={i} className={styles.star} />
        ))}
      </div>
      {titulo && <strong className={styles.titulo} title={titulo}>{titulo}</strong>}
      <p className={styles.mensaje}>{mensaje}</p>
      {nombre && (
        <div className={styles.footer}>
          <span className={styles.avatar} aria-hidden="true">{nombre.charAt(0)}</span>
          <div className={styles.infoCliente}>
            <span className={styles.nombre}>{nombre}</span>
            {localidad && <span className={styles.localidad}>{localidad}</span>}
          </div>
        </div>
      )}
    </div>
  );
};

export default ItemOpinion;
